/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_GemstonesInputs */

const en_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemstones`)
};

const es_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piedras preciosas`)
};

const fr_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierres précieuses`)
};

const de_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edelsteine`)
};

const ja_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宝石`)
};

const zh_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宝石`)
};

const ar_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأحجار الكريمة`)
};

const id_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batu Permata`)
};

const it_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pietre Preziose`)
};

const ru_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Драгоценные камни`)
};

const pt_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedras Preciosas`)
};

const ko_field_gemstones = /** @type {(inputs: Field_GemstonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보석류`)
};

/**
* | output |
* | --- |
* | "Gemstones" |
*
* @param {Field_GemstonesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_gemstones = /** @type {((inputs?: Field_GemstonesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_GemstonesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_gemstones(inputs)
	if (locale === "es") return es_field_gemstones(inputs)
	if (locale === "fr") return fr_field_gemstones(inputs)
	if (locale === "de") return de_field_gemstones(inputs)
	if (locale === "ja") return ja_field_gemstones(inputs)
	if (locale === "zh") return zh_field_gemstones(inputs)
	if (locale === "ar") return ar_field_gemstones(inputs)
	if (locale === "id") return id_field_gemstones(inputs)
	if (locale === "it") return it_field_gemstones(inputs)
	if (locale === "ru") return ru_field_gemstones(inputs)
	if (locale === "pt") return pt_field_gemstones(inputs)
	return ko_field_gemstones(inputs)
});